import { Link } from "react-router-dom";
import type { Comic } from "@/types/comic";

interface ComicCardProps {
  comic: Comic;
  variant?: "grid" | "horizontal";
}

export default function ComicCard({ comic, variant = "grid" }: ComicCardProps) {
  const latest = comic.chapters[comic.chapters.length - 1];

  if (variant === "horizontal") {
    return (
      <Link
        to={`/detail/${comic.id}`}
        className="group flex gap-3 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="relative w-20 h-28 shrink-0 rounded-md overflow-hidden bg-background-200">
          <img
            src={comic.cover}
            alt={`${comic.title} 封面`}
            title={`${comic.title} 漫画封面`}
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="min-w-0 flex flex-col py-0.5">
          <h3 className="font-heading font-bold text-base text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
            {comic.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author} 作品</p>
          <div className="flex flex-wrap gap-1 mt-2">
            {comic.genres.slice(0, 2).map((g) => (
              <span
                key={g}
                className="px-1.5 py-0.5 rounded text-[11px] bg-secondary-100 text-secondary-800"
              >
                {g}
              </span>
            ))}
          </div>
          <p className="mt-auto pt-2 text-xs text-primary-600 truncate">
            <i className="ri-refresh-line mr-1"></i>
            {latest ? latest.title : "暂无章节"}
          </p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${comic.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title} 封面`}
          title={`${comic.title} 漫画封面`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span
          className={`absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-medium ${
            comic.status === "连载"
              ? "bg-primary-500 text-background-50"
              : "bg-secondary-700 text-background-50"
          }`}
        >
          {comic.status}
        </span>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md text-[11px] font-medium bg-foreground-950/70 text-background-50 flex items-center gap-1">
          <i className="ri-star-fill text-primary-400"></i>
          {comic.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3 flex flex-col gap-2">
        <h3 className="font-heading font-bold text-base text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 truncate">{comic.author}</p>
        <div className="flex flex-wrap gap-1">
          {comic.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="px-1.5 py-0.5 rounded text-[11px] bg-secondary-100 text-secondary-800"
            >
              {g}
            </span>
          ))}
        </div>
        <p className="text-xs text-primary-600 truncate">
          <i className="ri-refresh-line mr-1"></i>
          {latest ? latest.title : "暂无章节"}
        </p>
      </div>
    </Link>
  );
}